exports = module.exports = require("../../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.qrcode-card .qrc-image[data-v-72b92e60] {\n  width: 80%;\n  padding-bottom: 80%;\n  margin: auto;\n  background: center center no-repeat;\n  background-size: contain;\n  margin-top: 0.5rem;\n  margin-bottom: 0.5rem;\n}\n.qrcode-card p[data-v-72b92e60] {\n  font-size: 13px;\n  color: #ffffff;\n  text-align: center;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/_css-loader@0.28.11@css-loader?{"minimize":false,"sourceMap":false}!./~/_vue-loader@11.3.4@vue-loader/lib/style-compiler?{"id":"data-v-72b92e60","scoped":true,"hasInlineConfig":true}!./~/_less-loader@4.0.5@less-loader/dist/cjs.js?{"sourceMap":false}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=styles&index=0!./src/views/pack/qrcode-card.vue
// module id = 728
// module chunks = 1